import loadable from "@loadable/component";
import Spinner from "../components/Reusable/Spinner";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import { lazy } from "@loadable/component";
import { Suspense } from "react";
import Skeleton from "../components/Reusable/Skeleton";
import usePostHook from "../customHooks/usePostHook";
import { queryClient } from "../router";

const Dashboard = lazy(() => import("../components/Dashboard"));

const OverView = () => {
  const { data: currentUserProfile, isLoading: isCurrentUserProfileLoading } =
    useGetHook({
      queryKey: ["current-user-profile"],
      url: `${APIS.STAFF}me/`,
      params: {},
    });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["cache-clear"],
  });
console.log("pradeep")
  const handleClearCache = async () => {
    const url = `${APIS.CACHE}`;
    const formData = {
      name: "overview",
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res?.status === 200) {
        const queriesToInvalidate = ["status", "payment-method"];
        queriesToInvalidate.forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
            refetchType: "active",
          });
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      {isCurrentUserProfileLoading ? (
        <Skeleton />
      ) : (
        <Suspense fallback={<Skeleton />}>
          <Dashboard
            currentUserProfile={currentUserProfile}
            isLoading={isPostLoading}
            handleClearCache={handleClearCache}
          />
        </Suspense>
      )}
    </>
  );
};

export default OverView;
